// extracted by mini-css-extract-plugin
export default {"switchAndUserinfoContainer":"NavigationSidebar_switchAndUserinfoContainer__42b9-","themeSwitch":"NavigationSidebar_themeSwitch__QTTFx"};